import { BEACON_EXPERIMENT_NAME } from '@/constants/global';

export default {
  mounted() {
    const showBeacon = this.$store.state.experiments[BEACON_EXPERIMENT_NAME];
    if (!showBeacon) return;
    const beaconScript = document.createElement('script');
    beaconScript.type = 'text/javascript';
    const beacon = '!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});';
    beaconScript.appendChild(document.createTextNode(beacon));
    document.body.appendChild(beaconScript);

    window.Beacon('init', '5a40c9f3-34e6-4673-b7f7-2c7153411305');
    window.Beacon('config', { display: { zIndex: 9999 } });
  },
  beforeDestroy() {
    // needed to remove when visiting other pages due to SPA
    const scriptElement = document.querySelectorAll('[src*="https://beacon-v2.helpscout.net"]');
    scriptElement.forEach((element) => element.remove());
    if (window.Beacon) {
      window.Beacon('destroy');
      delete window.Beacon;
    }
  },
};
